const state = {
	captchaResponse: null
}

const getters = {}

const mutations = {
	setCaptchaResponse: (state, value) => {
		state.captchaResponse = value
	}
}
const actions = {}

export default {
	state,
	getters,
	mutations,
	actions
}
